import exportPdf from './exportPdf'
import pages from './pages'

const supplierCompliance = {
  exportPdf,
  pages,
}

export default supplierCompliance
